<template>
  <va-card :title="$t('menu.freeTime')">
    <div class="flex xs6 sm3">
        <va-button
          medium
          inline
          color="green"
          icon="fa fa-download"
          class="ma-0"
          @click="exportFreeTimeReport()"
        >
          {{ $t('menu.export') }}
        </va-button>
      </div>
    <va-data-table
      :fields="fields"
      :data="free_times"
      no-pagination
      :loading="loading"
      >
      <template slot="actions" slot-scope="item">
        {{ elapsedTime(item.rowData.end_of_mounting, now) }}
      </template>
    </va-data-table>
  </va-card>


</template>

<script>

import FreeTimeAPI from '@/services/FreeTimeAPI'
import moment from 'moment'
import { mapState } from "vuex";

export default {
  data () {
    return {
      free_times: [],
      loading: true,
      now: new moment(),
      interval: '',
      }
  },

  channels: {
    NeedRefreshMountingTimes: {
      received(data) {
        this.getFreeTimes()
      },
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshMountingTimes', company: this.currentUser.company })

    this.getFreeTimes()
    this.interval = setInterval(() => { this.now = new moment() }, 1000)
  },

  beforeDestroy(){
    window.clearInterval(this.interval);
  },

  methods: {

    exportFreeTimeReport(){
      FreeTimeAPI.exportFreeTimeReport(this.currentLocality.id).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace("api/v1", "")
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        document.body.appendChild(link)
        link.href=this.filepath
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      });
    },

    async getFreeTimes(){
      await FreeTimeAPI.getFreeTimes(this.currentLocality.id).then(response => {
        this.free_times = response.data.free_times
        this.loading = false
      })
    },

    elapsedTime: function(end_of_mounting, now){
      var end_of_mounting = moment.utc(end_of_mounting)
      var duration = moment.duration(now.diff(end_of_mounting))
      var hours = duration._data.hours === 1 ? `${duration._data.hours} ${this.$t('tables.workTime.hour')}` : `${duration._data.hours} ${this.$t('tables.workTime.hours')}`
      var minutes = duration._data.minutes === 1 ? `${duration._data.minutes} ${this.$t('tables.workTime.minute')}` : `${duration._data.minutes} ${this.$t('tables.workTime.minutes')}`

      if (duration._data.hours > 0){
        return `${hours}, ${minutes} ${this.$t('tables.workTime.and')} ${duration._data.seconds} ${this.$t('tables.workTime.seconds')}`
      } else {
        return `${minutes} ${this.$t('tables.workTime.and')} ${duration._data.seconds} ${this.$t('tables.workTime.seconds')}`
      }
    },

    moment: function () {
      return moment();
    },
  },

  watch: {
    '$store.state.currentLocality': function() {
      this.getFreeTimes()
    }
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),

    fields () {
      return [{
        name: 'user_name',
        title: this.$t('tables.workTime.name'),
        width: '20%',
      },
      {
        name: 'login',
        title: this.$t('tables.freeTime.login'),
      },
      {
        name: '__slot:actions',
        title: this.$t('tables.freeTime.freeTime'),
      },
      {
        name: 'pallet_type',
        title: this.$t('tables.freeTime.palletKind'),
        width: '20%',
      },
      {
        name: 'latest_order',
        title: this.$t('tables.freeTime.orderCode'),
        width: '20%',
      }]
    }
  },
}
</script>
